import { render, staticRenderFns } from "./OrganigramaView.vue?vue&type=template&id=1f8aaa2e&"
import script from "./OrganigramaView.vue?vue&type=script&lang=ts&"
export * from "./OrganigramaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports